import type { ListEntry } from "@offsilo/contracts/settings";

/**
 * The label of a role id: the agency's list entry (archived entries too, so a held role keeps its word), else the preset
 * label, else the id with dashes read as spaces and the first letter in capitals.
 */
export function roleLabelOf(id: string, list: readonly ListEntry[], presets?: Partial<Record<string, () => string>>): string {
  const entry = list.find((e) => e.id === id);
  if (entry) return entry.label;
  const preset = presets?.[id];
  if (preset) return preset();
  const spaced = id.replace(/-/g, " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

/** The unarchived list ids in list order, then each id of `extra` not already there (owner and freelancer for a person picker). */
export function roleIdsOf(list: readonly ListEntry[], extra: readonly string[] = []): string[] {
  const ids = list.filter((e) => !e.archived).map((e) => e.id);
  for (const x of extra) if (!ids.includes(x)) ids.push(x);
  return ids;
}
